import { Controller } from "@hotwired/stimulus"

// Copies text from a data attribute to the clipboard on click, then briefly
// shows "Copied!" as confirmation. If a `label` target is present only its text
// is swapped (so an adjacent icon is preserved); otherwise the element's own
// text is swapped.
//
// Usage (text only):
//   <button data-controller="clipboard"
//           data-clipboard-content-value="text to copy"
//           data-action="click->clipboard#copy">Copy Query</button>
//
// Usage (with an icon — icon is preserved):
//   <button data-controller="clipboard" data-clipboard-content-value="…"
//           data-action="click->clipboard#copy">
//     <svg>…</svg><span data-clipboard-target="label">Copy</span>
//   </button>
export default class extends Controller {
  static values = { content: String }
  static targets = ["label"]

  copy() {
    const el = this.hasLabelTarget ? this.labelTarget : this.element
    const originalText = el.textContent
    navigator.clipboard.writeText(this.contentValue).then(() => {
      el.textContent = "Copied!"
      setTimeout(() => { el.textContent = originalText }, 2000)
    }).catch(err => {
      console.error("Failed to copy: ", err)
      el.textContent = "Copy failed"
      setTimeout(() => { el.textContent = originalText }, 2000)
    })
  }
}
